//#region src/generated/locales/be.ts
var templates = {
	"pd.submit.dialog.closeStay": `Bewerk gegevens`,
	"pd.submit.dialog.startPage": `Naar startpagina`
};
//#endregion
export { templates };
